module.exports = __webpack_public_path__ + "62fe8c1f1e7de613fd5c31a761f96943.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_11.png
// module id = 115
// module chunks = 1